module.exports = __webpack_public_path__ + "static/img/Philip_Wong.6f76728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Philip_Wong.png
// module id = 1590
// module chunks = 5